import { ENDPOINTS_LOANS } from 'common/endpoints/loans.endpoints';

export default class WageAdvanceService {
  constructor($http) {
    'ngInject';
    this.http = $http;
  }

  getReasonsList() {
    return this.http.get(ENDPOINTS_LOANS.get.wageAdvanceReasonsList()).then(response => {
      return response.data.wagesAdvanceReasonsList.map(this.formatReason);
    });
  }

  formatReason(reason) {
    return {
      option: reason.literal,
      value: reason.code,
    };
  }

  getEmployeeWagesAdvance(employeeId) {
    return this.http.get(ENDPOINTS_LOANS.get.employeeWagesAdvance(employeeId)).then(response => {
      return response.data.employeeWagesAdvance;
    });
  }

  postWagesAdvance(employeeId, params) {
    const wageAdvance = {
      wagesAdvance: [
        {
          amount: params.amount,
          reasonCode: params.code,
        },
      ],
    };
    return this.http.post(ENDPOINTS_LOANS.post.createWageAdvance(employeeId), wageAdvance);
  }

  deleteWageAdvance(employeeId, params) {
    const config = {
      data: {
        wagesAdvance: [
          {
            identifier: params.identifier,
            statusCode: params.statusCode
          }
        ]
      }
    };
    return this.http.delete(ENDPOINTS_LOANS.delete.deleteWageAdvance(employeeId), config);
  }
}



// WEBPACK FOOTER //
// ./client/app/loans.module/features/wageAdvance/wageAdvance.service.js